<div class="l-display-container mb-3">
  <label class="form-label section-info">{{ label() | translate }}</label>
  <div class="xl-display-text">
    <span>{{ displayText() | translate }}</span>
  </div>
</div>
